import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    contentItem: {
        width: '100%',
        height: 70,
        backgroundColor: '#fff',
        borderRadius: 8,
        padding: 10,
        flexDirection: 'row',
        marginBottom: 10,
        justifyContent: "space-between",
        alignContent: "center"
    },
    img: {
        width: 30,
        height: 30,
        marginTop: 10,
        marginLeft: 10,
        borderRadius: 30
    },
    textsItem: {
        marginLeft: 20,
        marginRight: "auto"
    },
    infoPrice: {
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    titleCoin: {
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 5
    },
    infosCoin: {
        fontSize: 10,
        color: '#2C2C2E',
        fontWeight: '400'
    },
    priceCoin: {
        fontSize: 10,
        color: '#2C2C2E',
        fontWeight: '600'
    },
    currencyPercentage: {
        color: 'green',
        fontSize: 10,
        position: 'absolute',
        right: 65,
        marginTop: 28
    },
    iconGo: {
        flexGrow: 0,
        marginTop: 10,
        flexDirection: 'column',
        alignItems: "center",
        justifyContent: "center"
    }
});

export default styles;